import React from 'react';
import { useTranslation } from 'react-i18next';
import { SortFilter } from '../SortFilter/SortFilter';
import { SortSubmenu } from '../SortSubMenu/SortSubMenu';
import './SortBy.scss';

export interface SortByProps {
  selectedKey?: string;
}

export const SortBy: React.FC<SortByProps> = ({ selectedKey }) => {
  const { t } = useTranslation();

  return (
    <div className="sort-by">
      <div className="sort-by__container">
        <div className="sort-by__main-row">
          <span className="sort-by__label">{t('sortBy.label')}</span>
          <SortFilter selectedKey={selectedKey} />
        </div>
        <div className="sort-by__submenu-row">
          <SortSubmenu />
        </div>
      </div>
    </div>
  );
};